// Renders a "text" type carousel banner from admin-editable DB fields.
// £-amounts in the headline are automatically highlighted in the accent color.
export const TextBanner = ({ banner }) => {
  const accent = banner.accent_color || "#FFC81E";
  const parts = (banner.headline || "").split(/(£\d+)/g);
  return (
    <div
      className="absolute inset-0 flex items-center justify-between px-4 sm:px-5"
      style={{ background: banner.bg_gradient || "#062B5C" }}
    >
      <div className="flex items-center gap-3 sm:gap-4 min-w-0">
        {(banner.brand || banner.brand_accent) && (
          <div
            className="hidden sm:flex items-center justify-center font-display font-black text-base leading-none px-2.5 py-1 rounded-md flex-shrink-0"
            style={{ background: "#FFFFFF", color: "#062B5C", letterSpacing: "-0.02em" }}
          >
            {banner.brand}
            <span style={{ color: accent }}>{banner.brand_accent}</span>
          </div>
        )}
        <div className="min-w-0">
          {banner.tagline && (
            <p
              className="font-mono text-[9px] uppercase tracking-[0.18em] truncate"
              style={{ color: "rgba(255,255,255,0.85)" }}
            >
              {banner.tagline}
            </p>
          )}
          <p
            className="font-display font-black text-sm sm:text-base lg:text-lg leading-tight truncate"
            style={{ color: "#FFFFFF", textShadow: "0 1px 2px rgba(0,0,0,0.4)" }}
          >
            {parts.map((p, i) =>
              /^£\d+$/.test(p) ? (
                <span key={i} style={{ color: accent }}>{p}</span>
              ) : (
                p
              )
            )}
          </p>
        </div>
      </div>
      <span
        className="font-mono text-[10px] sm:text-xs uppercase tracking-[0.16em] font-bold px-3 sm:px-4 py-1.5 sm:py-2 rounded-full inline-flex items-center gap-1 flex-shrink-0"
        style={{
          background: banner.cta_bg || "rgba(255,255,255,0.16)",
          color: "#FFFFFF",
          border: "1px solid rgba(255,255,255,0.35)",
          boxShadow: "inset 0 1px 0 rgba(255,255,255,0.35), 0 4px 12px -4px rgba(0,0,0,0.45)",
        }}
      >
        Claim Here →
      </span>
    </div>
  );
};

export default TextBanner;
